import { Input } from './Input.js';

export class RadioInput extends Input {
    checked(value = null) {
        if (value === null) {
            return this.element.checked;
        }
        return this.element.checked = value;
    }
}

